
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"35.382","height":"35.381"}},[_c('path',{attrs:{"d":"M35.382 17.69a17.691 17.691 0 10-20.455 17.476V22.804h-4.492V17.69h4.492v-3.9c0-4.434 2.641-6.883 6.682-6.883a27.235 27.235 0 013.96.345v4.357h-2.231a2.557 2.557 0 00-2.883 2.763v3.318h4.906l-.784 5.114h-4.122v12.362A17.7 17.7 0 0035.382 17.69","fill":"#337fff"}}),_c('path',{attrs:{"d":"M24.577 22.804l.784-5.114h-4.906v-3.319a2.556 2.556 0 012.883-2.762h2.231V7.255a27.181 27.181 0 00-3.961-.346c-4.04 0-6.681 2.45-6.681 6.883v3.9h-4.492v5.114h4.492v12.36a17.874 17.874 0 005.528 0V22.804z","fill":"#fff"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      